<template>
  <el-popover
    placement="top-start"
    trigger="click"
    title="Danh sách: "
    transition="el-zoom-in-bottom"
  >
    <slot></slot>
    <span slot="reference">
      <span class="highlight--name clickable tt-1">
        {{ word }}
      </span>
    </span>
  </el-popover>
</template>

<script>
  export default {
    name: "popover-word-2",
    props: ["word"],
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/common/popover-word-2.vue